import React, { useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { Button, Divider, Row, Switch } from 'antd'
import { ContactForm } from '@climatetrade/ui'
import styles from './ManagePermisionsPageContent.module.scss'
import { CustomCol, FormLabels, CustomText } from 'src/components'
import { Modal } from '@climatetradecarbon/climatetrade-components'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { CheckOutlined, CloseOutlined, SendOutlined } from '@ant-design/icons'
import { countryListSelector, trackEvent, updateUserAuthDetails, userAuthenticatedState } from 'src/features'
import ManagePermissionsChangeSubscription from './ManagePermissionsChangeSubscription/ManagePermissionsChangeSubscription'

const ManagePermisionsPageContent: React.FC = () => {
  const { t } = useTranslation()
  const { route } = useRouter()
  const { isMobile } = useWindowSize()
  const user = useAppSelector(userAuthenticatedState)
  const dispatch = useAppDispatch()
  const [isWidgetCheckbox, setIsWidgetCheckbox] = useState<boolean>(user?.is_widget)
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const countries = useAppSelector(countryListSelector)

  const updateWidgetRol = (is_widget: boolean) => {
    setIsWidgetCheckbox(is_widget)
    dispatch(updateUserAuthDetails({ is_widget }))
  }

  const boldDividerStyle = {
    height: '2px',
    background: 'rgba(0, 0, 0, 0.1)'
  }

  const handleTrackEvent = () => {
    dispatch(trackEvent(route, 'ACTION_CLICK', 'CONTACT_FORM_LEAD'))
  }

  return <>

    {/* Offsetter */}
    <Row className={isMobile && 'mt-5'}>
      <CustomCol xs={19}>
        <FormLabels
          title={t('Permisions.OffsetterLabel')}
          subtitle={t('Permisions.OffsetterSublabel')}
        />
      </CustomCol>
      <CustomCol xs={5}>
        <Switch
          checked={true}
          className={isMobile ? 'mt-2 ml-3' : 'ml-2'}
          disabled={true}
          checkedChildren={<CheckOutlined />}
        />
      </CustomCol>
    </Row>

    {/* Widget ROL */}
    {user.is_business && <>
      <Divider />
      <Row className={isMobile && 'mt-5'}>
        <CustomCol xs={19}>
          <FormLabels
            title={t('Permisions.WidgetLabel')}
            subtitle={t('Permisions.WidgetSublabel')}
          />
        </CustomCol>
        <CustomCol xs={5}>
          <Switch
            checked={isWidgetCheckbox}
            onChange={updateWidgetRol}
            className={isMobile ? 'mt-2 ml-3' : 'ml-2'}
            disabled={user.is_widget}
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
          />
        </CustomCol>
      </Row>
    </>}

    <Divider />

    <div className={styles.texts}>
      {user.is_business && <CustomText type='secondary' label={t('Permisions.DescriptionWidget')} />}
      <CustomText type='secondary' label={t('Permisions.DescriptionOffsetter')} />
    </div>

    <div className={styles.permisionsBtn}>
      <Button
        type='primary'
        size='middle'
        block={isMobile}
        className='float-right mt-2'
        icon={<SendOutlined />}
        onClick={() => setIsModalVisible(true)}
      >
        {t('Permisions.Contact')}
      </Button>

    </div>

    <Modal
      open={isModalVisible}
      onClose={() => setIsModalVisible(false)}
      title={t('Permisions.Contact')}
    >
      <ContactForm
        countries={countries}
        recaptchaKey={process.env.RECAPTCHA_PUBLIC_KEY}
        backendUrl={process.env.API_URL}
        handleClose={() => setIsModalVisible(false)}
        handleTrackEvent={handleTrackEvent}
      />
    </Modal>

    <Divider style={boldDividerStyle} />

    {/* Push Notifications */}
    <ManagePermissionsChangeSubscription />
  </>
}

export default ManagePermisionsPageContent
